<p-dialog
  *ngIf="dialogState.isOpen"
  [appendTo]="'body'"
  [(visible)]="dialogState.isOpen"
  [position]="'right'"
  [style]="{ width: '55vw', height: '100vh' }"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  (visibleChange)="closeDialog()"
>
  <div class="flex justify-content-between align-items-center mt-2">
    <div class="flex gap-2 align-items-center">
      <i
        class="pi pi-times secondary-button p-0 mr-2"
        (click)="closeDialog()"
      ></i>
      <button class="semiround-button" (click)="moveUp()" data-clarity-unmask="true">
        <i class="pi pi-angle-up"></i>
      </button>
      <button class="semiround-button" (click)="moveDown()" data-clarity-unmask="true">
        <i class="pi pi-angle-down"></i>
      </button>
      {{ dataIndex + 1 }} z {{ dataList.length }} wyników
    </div>
  </div>
  <ng-template pTemplate="content">
    <div class="flex justify-content-between align-items-center mt-5 mb-3">
      <div class="flex justify-content-center align-items-center gap-3">
        <div class="title-background-big">
          {{ data.oskName }}
        </div>
      </div>
      <!-- <p-button icon="pi pi-briefcase" label="Przydziel abonament"></p-button> -->
    </div>

    <p-tabView [(activeIndex)]="selectedTabIndex">
      <p-tabPanel header="Dane podstawowe">
        <form [formGroup]="oskForm" autocomplete="off">
          <div class="osk-form-pair flex gap-3 mt-5">
            <div
              class="form-decorator top-decorator flex w-full align-items-center"
            >
              <div class="title">Nazwa użytkownika</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="companyName"
                />
              </div>
            </div>
            <div
              class="form-decorator top-decorator flex w-full align-items-center"
            >
              <div class="title">NIP</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="nip"
                />
              </div>
            </div>
          </div>
          <div class="osk-form-pair flex gap-3">
            <div class="form-decorator flex w-full align-items-center">
              <div class="title">Imię</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="firstName"
                />
              </div>
            </div>
            <div class="form-decorator flex w-full align-items-center">
              <div class="title">Nazwisko</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="lastName"
                />
              </div>
            </div>
          </div>
          <div class="form-decorator flex align-items-center mt-5">
            <div class="title">ADRES</div>
          </div>
          <div class="osk-address-row form-decorator align-items-center flex gap-3">
            <div class="flex w-full align-items-center">
              <div class="title">Ulica</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="oskStreet"
                />
              </div>
            </div>
            <div class="flex w-full align-items-center">
              <div class="title">Kod pocztowy</div>
              <div class="form-wraper" (click)="editOn()">
                <input
                  [ngClass]="{ 'input-on': dialogState.isEditing }"
                  class="default-input"
                  type="text"
                  formControlName="oskPostalCode"
                />
              </div>
            </div>
          </div>
          <div class="form-decorator flex align-items-center">
            <div class="title">Miasto</div>
            <div class="form-wraper" (click)="editOn()">
              <input
                [ngClass]="{ 'input-on': dialogState.isEditing }"
                class="default-input"
                type="text"
                formControlName="oskCity"
              />
            </div>
          </div>
          <div class="form-decorator flex align-items-center">
            <div class="title">E-mail konta właściciela</div>
            <div class="form-wraper">
              <input
                class="default-input"
                type="text"
                [readonly]="true"
                formControlName="email"
              />
            </div>
          </div>
          <div class="form-decorator flex align-items-center gap-2">
            <div class="title">Adres e-mail OSK</div>
            <div class="form-wraper" (click)="editOn()">
              <input
                [ngClass]="{ 'input-on': dialogState.isEditing }"
                class="default-input"
                type="text"
                formControlName="oskEmail"
              />
            </div>
            <p-button styleClass="w-15rem" label="Wyślij link aktywacyjny" icon="pi pi-send" data-clarity-unmask="true" />
          </div>
          <div class="form-decorator flex align-items-center">
            <div class="title">Numer telefonu</div>
            <div class="form-wraper" (click)="editOn()">
              <input
                [ngClass]="{ 'input-on': dialogState.isEditing }"
                class="default-input"
                type="text"
                formControlName="oskPhone"
              />
            </div>
          </div>
          <div class="form-decorator flex align-items-center">
            <div class="title">Adres strony www</div>
            <div class="form-wraper" (click)="editOn()">
              <input
                [ngClass]="{ 'input-on': dialogState.isEditing }"
                class="default-input"
                type="text"
                formControlName="oskUrl"
              />
            </div>
          </div>
          <div class="form-decorator flex align-items-center">
            <div class="title">Skrócona nazwa</div>
            <div class="form-wraper" (click)="editOn()">
              <input
                [ngClass]="{ 'input-on': dialogState.isEditing }"
                class="default-input"
                type="text"
                formControlName="oskShortCode"
              />
            </div>
          </div>
        </form>
      </p-tabPanel>

      <p-tabPanel header="Abonamenty"> 
        <fas-services-table
        [value]="oskSubscriptions"
        [columns]="oskSubscriptionColumns"
        [rows]="10"
        [paginator]="false"
        [showCheckbox]="false"
        [showCurrentPageReport]="true"
        [(selection)]="subscriptionsSelected"
        [isTransparentHeader]="true"
      ></fas-services-table>
      </p-tabPanel>


      <p-tabPanel header="Transakcje"> 
        <fas-services-table
        [value]="oskOrderPacks"
        [columns]="oskOrderPackColumns"
        [rows]="10"
        [paginator]="false"
        [showCheckbox]="false"
        [showCurrentPageReport]="true"
        [(selection)]="transactionSelected"
        [isTransparentHeader]="true"
      ></fas-services-table>
      </p-tabPanel>
    </p-tabView>
  </ng-template>

  <ng-template pTemplate="footer">
    <div
      *ngIf="selectedTabIndex === 0"
      class="flex align-items-center justify-content-between"
    >
      <div *ngIf="!dialogState.isEditing">
        <p-button
          label="Edytuj konto"
          icon="pi pi-pencil"
          (click)="setEditMode(ID_dialog, true)"
          data-clarity-unmask="true"
        />
      </div>
      <div *ngIf="dialogState.isEditing" class="flex gap-2">
        <p-button
          label="Zapisz zmiany"
          (click)="updateOskDetails()"
          icon="pi pi-save"
          data-clarity-unmask="true"
        />
        <p-button
          styleClass="link-btn"
          label="Anuluj"
          [link]="true"
          (click)="setDefaultValues();setEditMode(ID_dialog, false)"
          data-clarity-unmask="true"
        />
      </div>
    </div>
  </ng-template>
</p-dialog>
